import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useMutationRemoveAccessViaProject, useQueryGetHub } from '../../../lockers/hubs.queries';
import { useQueryGetProjectOptional } from '../../../../core/queries/projects.queries';
import { RelationshipType } from '../../reducer/settings-tree-reducer.types';

export interface RemoveHubRelationshipModalProps {
  hubId: string;
  projectId: string;
  relationship: RelationshipType;
  onSuccess: () => void;
  onCancel: () => void;
}

export function RemoveHubRelationshipModal({
  hubId,
  projectId,
  relationship,
  onSuccess,
  onCancel
}: RemoveHubRelationshipModalProps) {
  const hubQuery = useQueryGetHub(hubId);
  const projectQuery = useQueryGetProjectOptional(projectId);
  const removeAccessVia = useMutationRemoveAccessViaProject();

  const hubName = hubQuery.data?.name ?? hubId;
  const projectName = projectQuery.data?.name ?? projectId;
  const isLoading = hubQuery.isLoading || projectQuery.isLoading || removeAccessVia.isLoading;

  const mutationForRelationship = () => {
    switch (relationship) {
      case RelationshipType.AccessedVia:
        return removeAccessVia.mutateAsync({ hubID: hubId, projectID: projectId });
      default:
        return;
    }
  };

  const getContent = (): string => {
    switch (relationship) {
      case RelationshipType.AccessedVia:
        return `This suggests that ${hubName} is not located in ${projectName} and will prevent access controls applying to ${projectName} from being presented to couriers wishing to use this hub.`;
      default:
        return ``;
    }
  };

  const onConfirm = async () => {
    await mutationForRelationship();
    onSuccess();
  };

  return (
    <ConfirmationModal
      title="Remove Relationship"
      content={[getContent()]}
      isLoading={isLoading}
      errorMessage={removeAccessVia.error ? 'Something went wrong. Please try again.' : undefined}
      onConfirm={onConfirm}
      onCancel={onCancel}
      cancelButton={{ label: 'Cancel', color: 'secondary' }}
      actionButton={{ label: 'Unlink', color: 'danger' }}
    />
  );
}
